import { useState, useEffect } from "react";
import { useAuth } from "../fetches/AuthorizationFetch";

const useRecruitsGetFetch = (page, limit, filter, sorting, refetchTrigger) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const { authenticatedFetch } = useAuth();

  useEffect(() => {
    let isCancelled = false;
    const fetchRecruits = async () => {
      setLoading(true);
      try {
        // Create base query params, now including page and limit
        const queryParamsObj = {
          ...(page && { page }),
          ...(limit && { limit }),
          ...(filter &&
            (filter.company || filter.companyId) && {
              company: filter.company || filter.companyId,
            }),
          ...(filter &&
            (filter.team || filter.teamId) && {
              team: filter.team || filter.teamId,
            }),
          ...(filter && filter.department && { department: filter.department }),
          ...(filter && filter.position && { position: filter.position }),
          ...(filter && filter.filter && { filter: filter.filter }),
          ...(filter && filter.rating && { rating: filter.rating }),
        };

        const queryParams = new URLSearchParams(queryParamsObj).toString();

        // Build URL with query params
        // Removed hardcoded limit=100000
        let url = `${process.env.REACT_APP_BASE_URL}/recruits/recruits?${queryParams}`;

        // Properly add sorting parameters if they exist
        if (sorting && sorting.length > 0) {
          const sortItem = sorting[0];
          if (sortItem && sortItem.id) {
            // Append sorting to the existing URL (which already has '?')
            url += `&sorting=${sortItem.desc ? "desc" : "asc"}:${sortItem.id}`;
          }
        }

        console.log("Recruits GET URL: ", url);
        const response = await authenticatedFetch(url);

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const jsonData = await response.json();
        console.log("Recruits GET response: ", jsonData);

        if (!isCancelled) {
          // console.log("Recruits GET response: ", jsonData);
          setData(jsonData);
          setError(null);
        }
      } catch (error) {
        if (!isCancelled) {
          console.error("Error fetching recruits:", error);
          setError(error.message);
        }
      } finally {
        if (!isCancelled) {
          setLoading(false);
        }
      }
    };

    fetchRecruits();

    return () => {
      isCancelled = true;
    };
  }, [
    page,
    limit,
    JSON.stringify(filter),
    JSON.stringify(sorting),
    refetchTrigger,
  ]);

  return { data, error, loading };
};

export default useRecruitsGetFetch;
